import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useEventBus } from "@vueuse/core";
import { BAlert } from "bootstrap-vue";
import { useGlobalUploadModal } from "@/composables/globalUploadModal";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryEmpty',
    props: {
        message: { default: "This history is empty." },
        writable: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        library.add(faInfoCircle);
        const { emit } = useEventBus("open-tool-section");
        const { openGlobalUploadModal } = useGlobalUploadModal();
        function clickDataLink() {
            emit("getext");
        }
        return { __sfc: true, emit, props, openGlobalUploadModal, clickDataLink, faInfoCircle, FontAwesomeIcon, BAlert, localize };
    }
});
